import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide } from './SlideShell';
import type { SlideProps } from './SlideShell';
const CAMPAIGN_FLOW_IMAGE = 'https://cdn.magicpatterns.com/uploads/qerT6p8x9rCk6qwxUuwwYc/Screenshot_2026-08-27_at_10.57.08.png';
export function Slide02ExecSummary({}: SlideProps) {
  return <InteriorSlide surface data-id="element-94" data-mp="19304wwctm6gk">
      <motion.header initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="mb-[clamp(1rem,1.8vw,1.75rem)] flex flex-shrink-0 items-end justify-between gap-8" data-id="element-95" data-mp="19046l6x29frl">
        <div data-id="element-96" data-mp="1mtby6yl56b9a">
          <p className="mb-2 text-[clamp(0.7rem,1vw,0.9rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-97" data-mp="1muwogc0fb81c">
            Turn-key campaign model
          </p>
          <h2 className="text-[clamp(2rem,3.3vw,3.2rem)] font-extrabold leading-tight tracking-[-0.035em] text-[var(--fg)]" data-id="element-98" data-mp="1wsb4iaifput4">
            From attention to insight—
            <span className="text-[var(--brand)]" data-id="element-99" data-mp="21oi1vewrlxzg">one connected loop.</span>
          </h2>
        </div>
        <p className="hidden max-w-sm text-right text-sm leading-relaxed text-[var(--muted)] lg:block" data-id="element-100" data-mp="2w2jxnx68me8y">
          Hook, participatory Snak, next-step CTA, and behavioral insights in one
          continuous campaign system.
        </p>
      </motion.header>

      <motion.figure initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.18,
      duration: 0.65
    }} className="flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-3xl border border-[var(--brand)]/10 bg-white p-3 shadow-sm" data-id="element-101" data-mp="2i6gfj28n1wcu">
        <img src={CAMPAIGN_FLOW_IMAGE} alt="Turn-key campaign flow from hook and interactive Snak through calls to action and campaign insights" className="h-full w-full object-contain" data-id="element-102" data-mp="3541h9piusy2e" />
      </motion.figure>
    </InteriorSlide>;
}